var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSvgShare = function SvgSvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.5 12.75a.75.75 0 0 1-.75-.75V8.25A3.754 3.754 0 0 1 13.5 4.5h6.439l-3.22-3.22a.74.74 0 0 1-.22-.53.75.75 0 0 1 1.281-.53l4.5 4.5a.7.7 0 0 1 .163.245l.01.026a.75.75 0 0 1-.174.79L17.78 10.28a.744.744 0 0 1-1.06 0 .74.74 0 0 1-.22-.53c0-.2.078-.389.22-.53L19.939 6H13.5a2.25 2.25 0 0 0-2.25 2.25V12a.75.75 0 0 1-.75.75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.75 24a2.25 2.25 0 0 1-2.25-2.25v-12A2.25 2.25 0 0 1 3.75 7.5H6A.75.75 0 0 1 6 9H3.75a.75.75 0 0 0-.75.75v12c0 .414.336.75.75.75h13.5a.75.75 0 0 0 .75-.75v-7.5a.75.75 0 0 1 1.5 0v7.5A2.25 2.25 0 0 1 17.25 24z"
  })));
};
export default SvgSvgShare;